import { useState, Link, motion, axios, Button, Input, Card, CardContent, CardHeader, CardTitle, CardDescription, Label, Loader2, Mail, LOGO_URL, API, toast } from "@/pages/shared";

export const ForgotPasswordPage = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email, origin_url: window.location.origin });
      setSent(true);
    } catch (error) {
      toast.error("Something went wrong. Please try again.");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 hero-glow">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-3 justify-center mb-8">
          <img src={LOGO_URL} alt="Creatara - Reset Your Password" className="w-12 h-12 rounded-xl" />
          <span className="text-2xl font-bold">Creatara</span>
        </Link>
        <Card className="glass">
          <CardHeader className="text-center">
            <CardTitle className="text-2xl">Reset Password</CardTitle>
            <CardDescription>{sent ? "Check your email" : "Enter your email to receive a reset link"}</CardDescription>
          </CardHeader>
          <CardContent>
            {sent ? (
              <div className="text-center space-y-4" data-testid="forgot-password-success">
                <div className="w-16 h-16 rounded-full bg-teal-500/20 flex items-center justify-center mx-auto">
                  <Mail className="w-8 h-8 text-teal-500" />
                </div>
                <p className="text-muted-foreground">If an account exists with <strong>{email}</strong>, you'll receive a password reset link shortly.</p>
                <Link to="/login"><Button variant="outline" className="rounded-full mt-4">Back to Login</Button></Link>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <Label>Email</Label>
                  <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" className="mt-1 bg-white/5 border-white/10" required data-testid="forgot-email-input" />
                </div>
                <Button type="submit" className="w-full btn-primary-glow bg-violet-600 hover:bg-violet-700 rounded-full" disabled={loading} data-testid="forgot-submit-btn">
                  {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Send Reset Link"}
                </Button>
                <p className="text-center text-sm text-muted-foreground">
                  <Link to="/login" className="text-violet-500 hover:underline">Back to Login</Link>
                </p>
              </form>
            )}
          </CardContent>
        </Card>
      </motion.div>
    </div>
  );
};
